import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { WidgetDeviceType, WidgetRenderLocation } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";
import { DeviceWidget } from "@src/domains/WidgetLibrary/DeviceWidget";

interface ContainerProps {
  children: React.ReactNode;
  renderLocation?: WidgetRenderLocation;
}

const Container = ({ children, renderLocation }: ContainerProps) => {
  const theme = useTheme();
  return (
    <Grid
      item
      container
      direction={"column"}
      borderRadius={"8px"}
      sx={{
        ...(renderLocation === "viewOnly" && {
          backgroundColor: theme.igBackgroundColors.baseLightLow,
        }),
      }}
      className={"container"}
    >
      {children}
    </Grid>
  );
};

interface LabelProps {
  label: string;
  children?: React.ReactNode;
  menu?: React.ReactNode;
  renderLocation?: WidgetRenderLocation;
}

const Label = ({ label, children, menu, renderLocation }: LabelProps) => {
  return (
    <Grid
      item
      container
      alignItems={"center"}
      justifyContent={"space-between"}
      wrap={"nowrap"}
      padding={"16px 16px 0 16px"}
    >
      <Grid item>
        <IgTypography fontWeight={600}>{label}</IgTypography>
      </Grid>
      <Grid
        item
        container
        justifyContent={"flex-end"}
        alignItems={"center"}
        spacing={1}
        xs={8}
      >
        {children && <Grid item>{children}</Grid>}
        {menu && renderLocation !== "settings" && <Grid item>{menu}</Grid>}
      </Grid>
    </Grid>
  );
};

interface WidgetsProps {
  children: React.ReactNode;
}

const Widgets = ({ children }: WidgetsProps) => {
  return (
    <Grid
      item
      sx={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {children}
    </Grid>
  );
};

interface WidgetProps {
  device: WidgetDeviceType;
  children: React.ReactNode;
  renderLocation?: WidgetRenderLocation;
}

const Widget = ({ device, children, renderLocation }: WidgetProps) => {
  return (
    <DeviceWidget device={device} renderLocation={renderLocation}>
      {children}
    </DeviceWidget>
  );
};

export const UserInterfaceWidgetPreview = Object.assign(Container, {
  Label,
  Widgets,
  Widget,
});
